import React from 'react';

// Aviso "Imagem meramente ilustrativa" sobre toda imagem gerada por IA. `overlay` = faixa no canto inferior da foto; senão vira legenda.
export const IllustrativeBadge = ({ text, overlay = true, className = '', testId = 'illustrative-badge' }) => (
  overlay ? (
    <span className={`absolute bottom-2 right-2 z-[1] pointer-events-none rounded-full bg-black/60 backdrop-blur-sm text-white/90 px-2.5 py-1 text-[10px] sm:text-[11px] italic leading-none ${className}`} data-testid={testId}>{text}</span>
  ) : (
    <p className={`text-[11px] italic text-slate-500 ${className}`} data-testid={testId}>{text}</p>
  )
);
